import { createContext } from 'react';

export const CONTEXT = createContext(null);
